/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocalDate } from '../../models/local-date';
import { TerytTercTo } from '../../models/teryt-terc-to';

export interface ApiWebTerytWojewodztwaWojPowiatyGet$Params {
  woj: string;
  date?: LocalDate;
}

export function apiWebTerytWojewodztwaWojPowiatyGet(http: HttpClient, rootUrl: string, params: ApiWebTerytWojewodztwaWojPowiatyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TerytTercTo>>> {
  const rb = new RequestBuilder(rootUrl, apiWebTerytWojewodztwaWojPowiatyGet.PATH, 'get');
  if (params) {
    rb.path('woj', params.woj, {});
    rb.query('date', params.date, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TerytTercTo>>;
    })
  );
}

apiWebTerytWojewodztwaWojPowiatyGet.PATH = '/api/web/teryt/wojewodztwa/{woj}/powiaty';
